import styled from "styled-components";
const Wrap = styled.div`
  display: flex;
  flex-direction: row;
  gap: 24px;
  padding-bottom: 40px;
  width: 100%;
  @media screen and (max-width: 760px) {
    flex-wrap: wrap;
  }
`;

export default Wrap;
